import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import DegreeAndDepartmentFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/DegreeAndDepartmentFilter'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Users/Partials/UsersFilter/Styles/style'
import React, { useEffect, useState } from 'react'
import CandidateRatingFilter from '../CandidateRating'
import CollegeNameFilter from '../CollegeName'
import LocationFilter from '../LocationFilter'

const CandidateViewFilter = ({
  searchValue,
  singleRoleData,
  setSearchValue,
  applicantCandidateList,
  candidateFilterData,
  setCandidateFilterData,
  setSearchParams,
  setStatus,
  filterStatus,
  setFilterStatus,
  candidateRating,
  setCandidateRating,
  candidateStatus,
  setCandidateStatus,
  degreeListData,
  checkedKeys,
  setCheckedKeys,
  checkedIds,
  setCheckedIds,
  atsBasedCollegeList,
  atsBasedLocationList,
  status,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [filteredData, setFilteredData] = useState({})
  const [college, setCollege] = useState()
  const [locationValue, setLocationValue] = useState([])
  const [locationSearch, setLocationSearch] = useState('')
  const [activeTabKey, setActiveTabKey] = useState('1')

  useEffect(() => {
   
 
    
    setLocationValue(candidateFilterData?.location)
 
    setCheckedIds(candidateFilterData?.degreeDepartment)
    setCheckedKeys(candidateFilterData?.degreekeys)
    setCollege(candidateFilterData?.collegeName)
 
  }, [candidateFilterData])
  const submitFilter = () => {
    setIsMenuOpen(false)
    setStatus(status)
    setFilterStatus(filteredData?.status)

    setFilteredData({
      ...filteredData,
      rating: candidateRating,
      location: locationValue,
      degree: checkedIds,
      degreeKeys: checkedKeys,
      status: filterStatus,
      collegeName: college,
    })
    setCandidateFilterData({
      rating: candidateRating || '',
      status: candidateStatus[0] || '',
      location: locationValue || '',
      degreeDepartment: checkedIds || [],
      degreekeys: checkedKeys,
      collegeName: college || '',
    })
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    setStatus(status)

    if (!open) {
      setCandidateRating(candidateFilterData?.rating)
      setLocationValue(candidateFilterData?.location)
      setCandidateStatus([candidateFilterData?.candidateStatus])
      setCheckedIds(candidateFilterData?.degreeDepartment)
      setCheckedKeys(candidateFilterData?.degreekeys)
      setCollege(candidateFilterData?.collegeName)
      setSearchParams({
        stage: filteredData?.round ? filteredData?.round : '',
      })
      setStatus(status)
    }
  }
  const handleTabChange = key => {
    setActiveTabKey(key)
  }
  const menu = (
    <MenuFlex column>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        onChange={handleTabChange}
        rightWidth={'60%'}
        width={'200px'}
        overflow={activeTabKey == '1' ? 'hidden' : 'auto'}
        overflowX={activeTabKey == '1' ? 'hidden' : 'auto'}
        items={[
          // singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
          //   ? {
          //       label: 'Candidate Rating',
          //       key: '1',
          //       children: (
          //         <CandidateRatingFilter
          //           candidateRating={candidateRating}
          //           setCandidateRating={setCandidateRating}
          //           sliderWidth={'95%'}
          //         />
          //       ),
          //     }
          //   : {},
          {
            label: 'Degree & Department',
            key: '2',
            children: (
              <DegreeAndDepartmentFilter
                degreeListData={degreeListData}
                checkedKeys={checkedKeys}
                setCheckedKeys={setCheckedKeys}
                checkedIds={checkedIds}
                setCheckedIds={setCheckedIds}
              />
            ),
          },
          {
            label: 'Location',
            key: '3',
            children: (
              <LocationFilter
                locationValue={locationValue}
                setLocationValue={setLocationValue}
                atsBasedLocationList={atsBasedLocationList || []}
                setLocationSearch={setLocationSearch}
                locationSearch={locationSearch}
                inputWidth={'100%'}
              />
            ),
          },
          singleRoleData?.jobTypeLevels?.[0] !== 'EXPERIENCED'
            ? {
                label: 'College Name',
                key: '4',
                children: (
                  <CollegeNameFilter
                    collegeList={atsBasedCollegeList}
                    college={college}
                    setCollege={setCollege}
                    searchWidth={'100%'}
                  />
                ),
              }
            : {},
        ]}
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary text="Apply Filter" onClick={submitFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      currentCount={
        applicantCandidateList?.count < 10
          ? applicantCandidateList?.count
          : applicantCandidateList?.candidateList?.length +
            applicantCandidateList?.page * 10
      }
      totalCount={applicantCandidateList?.count}
      onOpenChange={onCancelFilter}
    />
  )
}

export default CandidateViewFilter
